import React from 'react';
import { Link } from 'react-router-dom';
import { clients } from '../mock';
import { Users } from 'lucide-react';

const Clients = () => {
  if (clients.length === 0) return null;

  return (
    <section id="clientes" className="py-20 bg-slate-900 overflow-hidden" style={{ scrollMarginTop: '100px' }}>
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">Clientes Vip's</h2>
          <p className="text-xl text-blue-300 mb-3">Empresas que confiam em nossos serviços</p>
          <Link
            to="/clientes-vip"
            className="inline-flex items-center gap-2 text-cyan-400 hover:text-cyan-300 text-sm font-medium transition-colors"
            data-testid="ver-clientes-vip-link"
          >
            <Users className="w-4 h-4" />
            Ver todos os {clients.length} parceiros →
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8">
          {clients.map((client) => {
            const bgClass = client.darkLogo ? 'bg-slate-800' : 'bg-white';
            return (
              <div
                key={client.id}
                className={`flex items-center justify-center p-4 rounded-xl border border-slate-700 hover:border-cyan-500 transition-all duration-300 hover:shadow-lg hover:shadow-cyan-500/20 hover:-translate-y-2 cursor-pointer min-h-[120px] ${client.logo ? bgClass : 'bg-slate-800/50'}`}
              >
                {client.logo && client.website ? (
                  <a
                    href={client.website}
                    target="_blank"
                    rel="noopener noreferrer"
                    title={client.seoTitle || client.name}
                    aria-label={client.seoTitle || client.name}
                    className="w-full h-full flex items-center justify-center p-2"
                  >
                    <img
                      src={client.logo}
                      alt={client.seoAlt || client.name}
                      className="w-full h-full object-contain"
                    />
                    {/* Texto SEO invisível para crawlers */}
                    {client.seoKeywords && (
                      <span style={{ position: 'absolute', width: 1, height: 1, padding: 0, margin: -1, overflow: 'hidden', clip: 'rect(0,0,0,0)', whiteSpace: 'nowrap', border: 0 }}>
                        {client.seoKeywords}
                      </span>
                    )}
                  </a>
                ) : client.logo ? (
                  <div className="w-full h-full flex items-center justify-center p-2">
                    <img
                      src={client.logo}
                      alt={client.seoAlt || client.name}
                      className="w-full h-full object-contain"
                    />
                  </div>
                ) : null}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Clients;